import React from 'react'
import { Carousel } from 'antd';
import img1 from '../../images/carousel1.jpg'
import img2 from '../../images/carousel2.jpg'


function ListingPageCarousel() {
  return (
      <div className="mx-4 mt-4 mb-3">
        <Carousel autoplay={true} effect="scrollx" dotPosition="bottom">
            <div>
                <div className="" style={{height: "40vh"}}>
                    <img className="h-full w-full object-cover" src={img1} alt=""/>
                </div>
            </div>
            <div>
                <div className="" style={{height: "40vh"}}>
                    <img className="h-full w-full object-cover" src={img2} alt=""/>
                </div>
            </div>
        </Carousel>
    </div>
  );
}

export default ListingPageCarousel;
